import React from "react";
// import { Provider } from "react-redux";
// import reducer from "./redux/longRunningDelayedJobsReducer";
// import rootSaga from "./redux/longRunningDelayedJobsSaga";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
// import { createReduxStore } from "../../../utils/createReduxStore";
import { BlackListIpsModule } from "./blackListIpsModule";

const BlackListIps = (props) => {
  const { notifications } = props;

  return (
    // <Provider store={createReduxStore(reducer, "longRunningDelayedJobs", rootSaga)}>
    <ErrorBoundary moduleName="blackListIps" {...notifications}>
      <BlackListIpsModule />
    </ErrorBoundary>
    // </Provider>
  );
};

export default BlackListIps;
